export default __webpack_public_path__ + "static/media/nocard.8c1d09ea.svg";